export const MuiCircularProgress = {
  styleOverrides: {
    root: {
      color: 'rgba(30, 237, 159, 1)',
    },
  },
};
